import { NavBar } from "./components/navbar/navbar";
import { ImageSlider } from "./components/image-slider/slider";
import { BookingBar } from "./components/booking-bar/booking-bar";
import { Rooms } from "./components/rooms/rooms";
import { CTA } from "./components/cta/cta";
import { Services } from "./components/services/services";
import { Testimonial } from "./components/testimonial/testimonial";
import { ContactUs } from "./components/contact-us/contact";
import { Footer } from "./components/footer/footer";

function App() {
  return (
    <div className="App font-sans">
      <header className="App-header relative ">
        <NavBar />
      </header>
      <section id="image-slider">
        <ImageSlider />
      </section>
      <section className="md:hidden ">
        <BookingBar />
      </section>
      <section id="rooms">
        <Rooms />
      </section>
      <section id="cta">
        <CTA />
      </section>
      <section id="services">
        <Services />
      </section>
      <section id="testimonial">
        <Testimonial />
      </section>
      <section id="contactus">
        <ContactUs />
      </section>
      <footer id="footer">
        <Footer />
      </footer>
    </div>
  );
}

export default App;
